import { useMemo } from 'react';
import { Winning } from '../types/prize.types';
import { getPrizeStatus, getCurrentStep } from '../utils/prizeStatusUtils';
import { PAYMENT_STATUS } from '../types/payout.types';

export const usePrizeStepCalculation = (
    winning: Winning | undefined,
    identityTaxVerified: boolean,
    offlinePayment: boolean
): number => {
    return useMemo(() => {
        if (!winning) {
            return 0;
        }
        const isPrizeOffline = winning.eventOfflinePaymentMarked || offlinePayment;
        const paymentStatusCompleted = winning.paymentStatus === PAYMENT_STATUS.COMPLETED;
        const onlineInProgress =
            winning.paymentStatus === PAYMENT_STATUS.IN_PROGRESS && !isPrizeOffline;
        const offlinePay = winning.markedOfflinePay;
        if (paymentStatusCompleted || onlineInProgress || offlinePay) {
            return 3;
        } else {
            const status = getPrizeStatus(winning, identityTaxVerified, offlinePayment);
            return getCurrentStep(status);
        }
    }, [winning, identityTaxVerified, offlinePayment]);
};
